<template>
<div :class="classModal+ ' smodal'">
			<div class="modal-background"></div>
  			<div class="modal-card">
	    		<header class="modal-card-head" >
				      <p class="modal-card-title" style="width:90%;text-align:left" >{{title}}</p>	
				      <div style="float:rigth" v-if="close">
				      	<s-button theme="" label="" icon="times-circle" @onclick="$emit('close')"/>
				      </div>

				</header>
				<section class="modal-card-body">
					<slot></slot>
				</section>
				<footer class="modal-card-foot">
      				<div style="width:100%">
						  <div style="float: right" v-if="save">
      							<s-button :raccourci="raccourciSave" 
								  theme="button is-success" 
								  label="Enregistrer" 
								  icon="save" @onclick="saveButton"
								  :disabled="disabledSave"
								  ></s-button>
						  </div>
						<div style="float: left" v-if="deleteData">
							<s-button  theme="button is-danger" label="Supprimer" icon="trash" @onclick="deleteButton"></s-button>
						</div>
						<div style="float: left" v-if="cancel">
							<s-button theme="button is-warning" label="Annuler" icon="ban" @onclick="cancelButton"></s-button>
						</div>
      				</div>
					<div v-if="info" class="bottom_footer">
						{{info}}
					</div>
    			</footer>
  			</div>
  			
			</div>
		</div>
</template>
<style scoped>
	section {
		color: black;
	}
	.smodal {
		z-index: 200;
		position: fixed;
	}
	.bottom_footer {
		position: absolute;
		top: 0px;
		font-size: 14px;
		font-weight: bolder;
		color: black;

	}
</style>
<script>
	export default  {
		props: ["title","save","cancel","deleteData","open","close","raccourciSave", "disabled","info"],
		data() {
			return {
				classModal: "modal"
			}
		},
		watch: {
			open: function(val) {
               
				if (val)
					this.classModal = "modal is-active";
				else
					this.classModal = "modal";
			}
		},
		mounted() {
			if (this.open)
					this.classModal = "modal is-active";
				else
					this.classModal = "modal";
		},
		computed: {
			disabledSave: {
				get() {
					if (typeof(this.disabled) != "undefined")
						return this.disabled;
					else
						return false;
				}
			}
		},
		methods: {
			saveButton () {
				this.$emit("save")
			},
			cancelButton () {
				
				this.$emit("cancel");
			},
			deleteButton() {
				this.$emit("delete");
			}
			
		}
	}
</script>